const getId = (item: any): string => {
  const ids = item && typeof item.objectDb === "number" ? `${item.objectDb},${item.objectId}` : "";
  return ids !== "0,0" ? ids : "";
};

export default getId;
